/**
 * Delete Invoice Attachment Use Case
 *
 * Business logic for deleting invoice attachment following clean architecture principles.
 */

import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';

export class DeleteInvoiceAttachmentUseCase {
  constructor (private repository: SalesDashboardRepository) {}

  async execute (invoiceId: string | number): Promise<void> {
    if (!invoiceId) {
      throw new Error('معرف الفاتورة غير صحيح');
    }

    await this.repository.deleteInvoiceAttachment(invoiceId);
  }
}
